document.addEventListener('DOMContentLoaded', () => {
  /**
   * 1) Dawn cart component resolver (drawer preferred)
   */
  const getCartObject = () =>
    document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  /**
   * 2) Fetch helpers
   */
  const fetchCartJson = async () => {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('Failed to fetch /cart.js');
    return res.json();
  };

  const fetchSections = async (sectionIds) => {
    const root = window.Shopify?.routes?.root || '/';
    const url = `${root}?sections=${encodeURIComponent(sectionIds.join(','))}`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Failed to fetch section rendering JSON');
    return res.json(); // { "cart-drawer": "<div>...</div>", ... }
  };

  /**
   * 3) Build the "parsedState" object Dawn expects
   *    (mirrors the shape returned by /cart/add.js with bundled section rendering)
   */
  const buildParsedState = (cart, sections) => {
    const lastItem = Array.isArray(cart?.items) && cart.items.length
      ? cart.items[cart.items.length - 1]
      : null;

    return {
      // Dawn uses this in a few places; "key" is a good bet, fallback to variant_id
      id: lastItem?.key || lastItem?.variant_id || null,

      // REQUIRED for renderContents
      sections,
      sections_url: window.location.pathname + window.location.search,

      // Helpful/commonly expected fields (comes from /cart.js)
      token: cart?.token,
      note: cart?.note,
      attributes: cart?.attributes,
      item_count: cart?.item_count,
      items: cart?.items,
      total_price: cart?.total_price,
      original_total_price: cart?.original_total_price,
      total_discount: cart?.total_discount,
      currency: cart?.currency,
    };
  };

  /**
   * 4) Refresh + open drawer
   */
  const renderAndOpenDrawer = async () => {
    const cartObject = getCartObject();
    if (!cartObject) return;

    // Prefer Dawn’s own section list when available
    const sectionIds =
      typeof cartObject.getSectionsToRender === 'function'
        ? cartObject
            .getSectionsToRender()
            .map((s) => s.section || s.id)
            .filter(Boolean)
        : ['cart-drawer', 'cart-icon-bubble'];

    const [cart, sections] = await Promise.all([fetchCartJson(), fetchSections(sectionIds)]);
    const parsedState = buildParsedState(cart, sections);

    // Ensure drawer isn’t treated as empty
    cartObject.classList?.remove('is-empty');

    // Render + open
    if (typeof cartObject.renderContents === 'function') {
      cartObject.renderContents(parsedState);
    }
    if (typeof cartObject.open === 'function') {
      cartObject.open();
    }
  };

  /**
   * 5) CPB hook: AFTER CPB adds the product to cart
   *    CPB docs show this event on document. :contentReference[oaicite:2]{index=2}
   *    We'll listen on both document and body for safety.
   */
  const onCpbAdded = async (event) => {
    try {
      // Small defer helps if CPB fires the event before the theme finishes its own cart sync
      setTimeout(() => {
        renderAndOpenDrawer().catch((e) => console.warn('CPB -> drawer failed:', e));
      }, 0);
    } catch (e) {
      console.warn('CPB add handler failed:', e);
    }
  };

  document.addEventListener('cpb-add-to-cart', onCpbAdded);
  document.body?.addEventListener?.('cpb-add-to-cart', onCpbAdded);
});